import currency from "currency.js"
export const fnFormatNumb = (value = 0, decComma = false) => currency(value, { symbol: "", decimal: decComma ? ',' : '.' }).format()